/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ContractDetailsAliases {
  AUTOCOMPLETE_MENU_MOBILE = 'autocomplete-menu-mobile',
  BREADCRUMB_CONTRACTUAL_DRAFT = 'breadcrumb-contractual-draft',
  CONTEXTUAL_BAR_CLAUSE = 'contextual-bar-clause',
  FETCH_CLAUSE = 'fetch-clause',
  FETCH_CLAUSES = 'fetch-clauses',
  FETCH_MENU_MOBILE = 'fetch-menu-mobile',
  FIELD_0 = 'field-0',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_ATTACHMENT = 'field-attachment',
  FIELD_CLAUSES = 'field-clauses',
  FIELD_FILTER = 'field-filter',
  FORM_0 = 'form-0',
  FORM_1 = 'form-1',
  FORM_MENU_MOBILE = 'form-menu-mobile',
  FRAGMENT_1 = 'fragment-1',
  HPMS_TEXT_HTML_0 = 'hpms-text-html-0',
  INPUT_FILTER = 'input-filter',
  LAYOUT_0 = 'layout-0',
  LAYOUT_CONTRACTUAL_BAR = 'layout-contractual-bar',
  LINK_ATTACHMENT = 'link-attachment',
  LOADER_0 = 'loader-0',
  MAPPER_0 = 'mapper-0',
  MAPPER_ATTACHMENT = 'mapper-attachment',
  PANEL_0 = 'panel-0',
  PANEL_2 = 'panel-2',
  PANEL_ATTACHMENTS = 'panel-attachments',
  PANEL_CLAUSE = 'panel-clause',
  PANEL_CONTRACTUAL_DRAFT = 'panel-contractual-draft',
  PANEL_FILTER = 'panel-filter',
  PANEL_LEVEL = 'panel-level',
  PANEL_LOADER = 'panel-loader',
  PANEL_MOBILE = 'panel-mobile',
  PANEL_REPEATER = 'panel-repeater',
  PANEL_SIDEBAR = 'panel-sidebar',
  PANEL_TITLE = 'panel-title',
  REPEATER_REQUEST_DIAGNOSIS = 'repeater-request-diagnosis',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
}
export { ContractDetailsAliases };
